<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="未排产工单"
      :page="false"
      :show-query="true"
      :get-data-func="api.getWorkDocProductPlanList"
      subTableShowToolbar
      subTableText="未排产的布产单明细"
      urlHash="production/scheduling/equipmentscheduling/notScheduling"
      @subTableEnter="subTableEnter"
      :temp-params="tempParams"
      @getDataEnd="resetDataFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <el-table slot="subTable" @selection-change="handleSelectionChange" class="tb-c-head" :data="tableData" border style="margin-bottom: 18px" max-height="500">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="订单号" prop="OrderNo" min-width="170" show-overflow-tooltip />
        <el-table-column label="布产单号" prop="OrderProductNo" min-width="170" show-overflow-tooltip />
        <el-table-column label="单据日期" prop="OrderDate" min-width="120" show-overflow-tooltip />
        <el-table-column label="客户名称" prop="FullName" min-width="120" />
        <el-table-column label="部门" prop="DpName" min-width="70" />
        <el-table-column label="业务员" prop="EmpName" width="80" />
        <el-table-column label="存货编码" prop="ProductNo" width="90" />
        <el-table-column label="存货名称" prop="ProductName" width="100" />
        <el-table-column label="适用bom" prop="ProductBomNo" width="100" />
        <el-table-column label="颜色" prop="ColorName" width="100" />
        <el-table-column label="单位" prop="SaUnitName" width="100" />
        <el-table-column label="数量" prop="SaQuantity" width="100" />
      </el-table>
      <template slot="tabs">
        <el-tabs v-model="tabName" type="card" @tab-click="tabClick">
          <!-- <el-tab-pane :label="'注塑工单' + '(' + Injection.length + ')'" name="0"></el-tab-pane>
          <el-tab-pane :label="'胶件加工工单' + '(' + Special.length + ')'" name="1"></el-tab-pane>
          <el-tab-pane :label="'配件工单' + '(' + Parts.length + ')'" name="2"></el-tab-pane>
          <el-tab-pane :label="'装配工单' + '(' + Assembling.length + ')'" name="3"></el-tab-pane>
          <el-tab-pane :label="'组合工单' + '(' + Combination.length + ')'" name="4"></el-tab-pane> -->

          <el-tab-pane v-for="(item, index) in machiningStageList" :key="index" :label="item.Name + '工单' + '(' + item.Len + ')'" :name="item.MachiningStageId + ''"></el-tab-pane>
        </el-tabs>
      </template>
      <template slot="table">
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{ row, $index }">
            <el-button v-if="$permission.canWrite()" type="text" @click="edit(row, $index)">编辑</el-button>
            <el-button v-if="$permission.canWrite()" type="text" @click="drain(row)">排入</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <team-dialog ref="teamDialog" @change="changePlanDts"></team-dialog>
    <drain-dialog ref="drainDialog" @changeDrain="changeDrain"></drain-dialog>
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import tableColumn from '@/data/production/scheduling/teamscheduling/notScheduling/list.json'
import tableParam from '@/data/production/scheduling/teamscheduling/notScheduling/query.json'

import teamDialog from './teamDialog'
import drainDialog from './drainDialog'

export default {
  mixins: [listMixin],
  components: { list, teamDialog, drainDialog },
  props: {
    dpid: {
      type: Number,
      default: null
    }
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      clothProductionApi: require('@/api/production/clothProduction').default,
      api: require('@/api/pu/plan').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      params: {
        Order: '',
        SubOrder: '',
        CustomerName: '',
        DocTime: '',
        StockName: '',
        Remark: '',
        Department: '',
        Salesman: ''
      },
      tableData: [],
      result: {},
      index: 0,
      _dpid: null,
      tabName: '0',
      tempParams: {
        SchedulingType: 1,
        IsScheduling: false,
        MaintenanceId: null,
        OrderProductIds: []
      },
      OrderProductIds: [],
      Combination: [],
      Assembling: [],
      Parts: [],
      Special: [],
      Injection: [],
      wid: 0,
      aleayCombination: [],
      aleayAssembling: [],
      aleayParts: [],
      aleaySpecial: [],
      aleayInjection: [],
      machiningStageList: []
    }
  },
  watch: {
    dpid(val) {
      this.tempParams.MaintenanceId = val
      this.subTableEnter()
    }
  },
  created() {
    this.clothProductionApi
      .list({
        IsUnScheduled: true,
        SchedulingType: 1
      })
      .then(res => {
        console.log('res', res)
        if (res.Code === 0) {
          res.Data.forEach(item => {
            item.OrderDate = this.toDateString(item.OrderDate)
          })
          this.tableData = res.Data
        }
      })
    this.machiningStageApi.list({ Status: 1 }).then(res => {
      this.machiningStageList = res.Data
      this.machiningStageList.forEach(x => {
        if (x.MachiningStageId == 1) {
          x.MachiningStageId = 0
        }
        x.Len = 0
        x.datas = []
      })
    })
  },

  methods: {
    setAleayData(data) {
      let { Combination, Assembling, Parts, Special, Injection } = data

      this.aleayCombination = Combination
      this.aleayAssembling = Assembling
      this.aleayParts = Parts
      this.aleaySpecial = Special
      this.aleayInjection = Injection
    },
    changeDrain() {
      this.subTableEnter()
    },
    changeTeam() {
      this.subTableEnter()
    },
    changePlanDts(data) {
      console.log(data, 'aa')
      //this.subTableEnter()
      var stage = this.machiningStageList.find(x => x.MachiningStageId == Number(this.tabName))
      if (stage) {
        var datas = stage.datas
        var row = datas[data.index]
        row.Schedule = data.Schedule
        row.MaintenanceName = data.Maintenance
        row.Team = data.Team
        row.PlanDts = data.PlanDts
        this.$refs.list.setTable(datas)
      }
    },
    toDateStringByFormat(value, format) {
      if (!value) return ''
      let m = this.$moment(value)
      if (!m.isValid()) {
        return ''
      }
      return m.format(format)
    },
    //返回YYYY-MM-DD格式的字符串
    toDateString(value) {
      return this.toDateStringByFormat(value, 'YYYY-MM-DD')
    },
    handleSelectionChange(rows) {
      this.OrderProductIds = rows.map(item => {
        return item.OrderProductId
      })

      this.tempParams.OrderProductIds = this.OrderProductIds
    },
    addIndex(arr) {
      arr.forEach((item, i) => {
        item.indexNumber = i + 1
      })

      return arr
    },
    setInjection(data) {
      data.forEach(item => {
        item.ProductName = item.MouldName
        item.ProductNo = item.MouldNo
      })

      return data
    },
    resetDataFunc(resData) {
      let Combination = []
      let Assembling = []
      let Parts = []
      let Special = []
      let Injection = []

      let data = resData
      let length = data.length

      let dps = data.map(item => {
        return item.MaintenanceName
      })

      dps = Array.from(new Set(dps))

      dps = dps.filter(item => {
        return item != null
      })

      let arr = []
      dps.forEach(item => {
        let arr1 = data.filter(v => {
          return item === v.MaintenanceName
        })
        let o = {
          dps: arr1
        }
        arr.push(o)
      })

      let dpSelect = []
      arr.forEach(item => {
        let o = {
          ProductionDpId: item.dps[0]?.MaintenanceId,
          ProductionDpName: item.dps[0]?.MaintenanceName,
          ProductionDpNumber: item.dps.length
        }
        dpSelect.push(o)
      })
      console.log(dpSelect, 'dpSelect')
      this.$emit('getDp', dpSelect)
      // for (let i = 0; i < length; ++i) {
      //   let stage = data[i].Stage
      //   switch (stage) {
      //     case 0:
      //       Injection.push(data[i])
      //       break
      //     case 1:
      //       Special.push(data[i])
      //       break
      //     case 2:
      //       Parts.push(data[i])
      //       break
      //     case 3:
      //       Assembling.push(data[i])
      //       break
      //     case 4:
      //       Combination.push(data[i])
      //       break
      //   }
      // }

      this.machiningStageList.forEach((x, index) => {
        var list = data.filter(w => w.Stage == x.MachiningStageId)
        if (x.MachiningStageId == 0) {
          list = this.setInjection(list)
        }
        x.datas = this.addIndex(list)
        x.Len = x.datas.length

        this.$set(this.machiningStageList, index, x)
      })

      var stage = this.machiningStageList.find(x => x.MachiningStageId == this.tabName)
      if (stage) this.$refs.list.setTable(stage.datas)
      // this.Combination = this.addIndex(Combination)
      // this.Assembling = this.addIndex(Assembling)
      // this.Parts = this.addIndex(Parts)
      // this.Special = this.addIndex(Special)
      // Injection = this.setInjection(Injection)
      // this.Injection = this.addIndex(Injection)

      // if (this.tabName === '0') this.$refs.list.setTable(this.Injection)
      // if (this.tabName === '1') this.$refs.list.setTable(this.Special)
      // if (this.tabName === '2') this.$refs.list.setTable(this.Parts)
      // if (this.tabName === '3') this.$refs.list.setTable(this.Assembling)
      // if (this.tabName === '4') this.$refs.list.setTable(this.Combination)

      this.$emit('listEnd', { OrderProductIds: this.OrderProductIds })
    },
    subTableEnter() {
      this.$refs.list.getData()
      var data = this.$refs.list.data
      console.log(data, 'sutableenter')
      this.machiningStageList.forEach((x, index) => {
        var list = data.filter(w => w.Stage == x.MachiningStageId)
        if (list) {
          if (x.MachiningStageId == 0) {
            list = this.setInjection(list)
          }
          x.datas = this.addIndex(list)
          x.Len = x.datas.length
        } else {
          x.datas = []
          x.Len = 0
        }
        this.$set(this.machiningStageList, index, x)
      })
      var stage = this.machiningStageList.find(x => x.MachiningStageId == this.tabName)
      if (stage) this.$refs.list.setTable(stage.datas)
      // // 根据勾选的内容搜索
      // var loading = this.$loading({
      //   lock: true,
      //   text: "正在更新...",
      //   spinner: "el-icon-loading",
      //   customClass: "my_loading",
      //   background: "rgba(0, 0, 0, 0.3)",
      // });
      // let data = {};
      // if(this.tempParams.ProductionDpId === 0 || this.tempParams.ProductionDpId == null){
      //   data = { OrderProductIds: this.OrderProductIds, SchedulingType: 0, IsScheduling: false }
      // }else{
      //   data = { OrderProductIds: this.OrderProductIds, SchedulingType: 0, IsScheduling: false, ProductionDpId: this.tempParams.ProductionDpId }
      // }
      // this.api
      //   .proList(data)
      //   .then((res) => {
      //     console.log("res", res);
      //     if (res.Code === 0) {

      //       let Combination = [];
      //       let Assembling = [];
      //       let Parts = [];
      //       let Special = [];
      //       let Injection = [];

      //       let data = res.Data;
      //       let length = data.length;

      //       let dps = data.map(item => {
      //         return item.ProductionDpName;
      //       })

      //       dps = Array.from(new Set(dps));

      //       dps = dps.filter(item => {
      //         return item != null
      //       })

      //       let arr = [];
      //       dps.forEach(item => {
      //         let arr1 = data.filter(v => {
      //           return item === v.ProductionDpName;
      //         })
      //         let o = {
      //           dps: arr1,
      //         }
      //         arr.push(o)
      //       })

      //       let dpSelect = [];
      //       arr.forEach(item => {
      //         let o = {
      //           ProductionDpId:item.dps[0]?.ProductionDpId,
      //           ProductionDpName:item.dps[0]?.ProductionDpName,
      //           ProductionDpNumber:item.dps.length,
      //         }
      //         dpSelect.push(o)
      //       })

      //       this.$emit('getDp', dpSelect)
      //       for (let i = 0; i < length; ++i) {
      //         let stage = data[i].Stage;
      //         switch (stage) {
      //           case 0:
      //             Injection.push(data[i]);
      //             break;
      //           case 1:
      //             Special.push(data[i]);
      //             break;
      //           case 2:
      //             Parts.push(data[i]);
      //             break;
      //           case 3:
      //             Assembling.push(data[i]);
      //             break;
      //           case 4:
      //             Combination.push(data[i]);
      //             break;
      //         }
      //       }

      //       this.Combination = Combination;
      //       this.Assembling = Assembling;
      //       this.Parts = Parts;
      //       this.Special = Special;
      //       this.Injection = Injection;

      //       if (this.tabName === "0") this.$refs.list.setTable(this.Injection);
      //       if (this.tabName === "1") this.$refs.list.setTable(this.Special);
      //       if (this.tabName === "2") this.$refs.list.setTable(this.Parts);
      //       if (this.tabName === "3") this.$refs.list.setTable(this.Assembling);
      //       if (this.tabName === "4") this.$refs.list.setTable(this.Combination);

      //       this.$emit('listEnd', {OrderProductIds: this.OrderProductIds})

      //     }

      //     loading.close()

      //   }).catch(err => {
      //     loading.close()
      //   })
    },
    // queryBefore() {
    //   console.log("this._dpid", this._dpid);
    //   return this._dpid;
    // },
    tabClick() {
      console.log('tab', this.tabName)
      var stage = this.machiningStageList.find(x => x.MachiningStageId == this.tabName)
      if (stage) this.$refs.list.setTable(stage.datas)

      // if (this.tabName === '0') this.$refs.list.setTable(this.Injection)
      // if (this.tabName === '1') this.$refs.list.setTable(this.Special)
      // if (this.tabName === '2') this.$refs.list.setTable(this.Parts)
      // if (this.tabName === '3') this.$refs.list.setTable(this.Assembling)
      // if (this.tabName === '4') this.$refs.list.setTable(this.Combination)
      // this.$refs.list.getData({ Stage: this.tabName });
    },

    // _getData(params) {
    //   this.getData(params);
    // },
    edit(row, index) {
      let { WorkDocId, TeamId, Team, ScheduleId, Schedule, PlanDts, Quantity,Stage  } = row
      let arr = []
      arr.push(WorkDocId)
      let o = {
        WorkDocIds: arr,
        TeamId,
        Team,
        ScheduleId,
        Schedule,
        PlanDts,
        Quantity,
        index,Stage 
      }

      this.$refs.teamDialog.openEdit(o)
    },
    drain(row) {
      this.$refs.drainDialog.openEdit(row).then(that => {
        let arr = []
        // if (this.tabName === '0') arr = this.aleayInjection
        // if (this.tabName === '1') arr = this.aleaySpecial
        // if (this.tabName === '2') arr = this.aleayParts
        // if (this.tabName === '3') arr = this.aleayAssembling
        // if (this.tabName === '4') arr = this.aleayCombination
        var stage = this.machiningStageList.find(x => x.MachiningStageId == this.tabName)
        if (stage) arr = stage.datas
        arr = arr.filter(item => {
          return item.Status === 0
        })
        let workDocs = []
        arr.forEach(item => {
          let o = {
            WorkDocNo: item.WorkDocNo,
            WorkDocId: item.WorkDocId
          }
          workDocs.push(o)
        })

        that.workDocs = workDocs
        that.data.WorkDocNo = ''
      })
    }
  }
}
</script>
